import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Select, Form, Row, Col } from 'antd';

const { Option } = Select;

const Search = ({ form, onSearch, onReset, staticProps }) => {
  const {
    searchLabel,
    resetLabel,
    inputPlaceholder,
    searchOptions,
  } = staticProps;

  const renderSearchOptions = () =>
    searchOptions.map(({ value, label }) => (
      <Option value={value} key={value}>
        {label}
      </Option>
    ));

  return (
    <section className="grey-section">
      <Form form={form} onFinish={onSearch} initialValues={{ param: 'name' }}>
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item name="param" rules={[{ required: true }]}>
              <Select>{renderSearchOptions()}</Select>
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item name="val" rules={[{ required: true }]}>
              <Input placeholder={inputPlaceholder} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                {searchLabel}
              </Button>
              <Button htmlType="button" onClick={onReset}>
                {resetLabel}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </section>
  );
};

Search.propTypes = {
  form: PropTypes.object.isRequired,
  onSearch: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  staticProps: PropTypes.shape({
    submitLabel: PropTypes.string.isRequired,
    resetLabel: PropTypes.string.isRequired,
    inputPlaceholder: PropTypes.string.isRequired,
    searchOptions: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      })
    ),
  }),
};

export default Search;
